import {Reveal} from 'components/animation'

import './style.css'

export default function Frame({reveal = false, children, ...props}) {
    const frame = <section {...props} className="frame">{children}</section>

    if (! reveal) return frame

    return <Reveal start={0} duration={200}>{frame}</Reveal>
}
